import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { colors, duration } from "utils/styles";

export default function SkeletonLoader({
	count = 1,
	highlightColor = "lightGray",
	baseColor = "mediumGray",
	width = "100px",
	height = "2em",
	className = "",
}) {
	return (
		<Skeleton
			className={className}
			highlightColor={colors[highlightColor]}
			baseColor={colors[baseColor]}
			width={width}
			height={height}
			count={count}
		/>
	);
}
